// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"309":"b796439c","458":"6864b903","631":"8c6c75c1","774":"9a42e461","858":"9d7fbf5c"}[chunkId] + ".chunk.js";
};